// Portfolio data for Pramith Rajapaksa

export const profileData = {
  name: "Pramith Rajapaksa",
  role: "Senior Full-Stack Software Engineer",
  tagline: "React · TypeScript · Node.js · AWS Serverless",
  headline: "Senior Full-Stack Software Engineer",
  intro: "Senior Software Engineer with 5+ years of experience building scalable web and mobile applications. Strong focus on clean architecture, frontend excellence, and leading teams to deliver high-impact software solutions.",
  email: "pramythrajapaksa@gmail.com",
  location: "Colombo, Sri Lanka",
  experience: "5+ years",
  github: "https://github.com/pramith",
  linkedin: "https://linkedin.com/in/pramitha-rajapaksa"
};

export const aboutData = {
  bio: `Full-stack engineer with deep expertise in React, TypeScript, Node.js, and AWS Serverless. I build scalable, maintainable software with a focus on clean architecture and exceptional user experiences.

Experienced working with stakeholders across UAT and production deployments, I bring both technical depth and strong communication to every project.`,
  highlights: [
    "Clean code & design patterns",
    "Test-driven development",
    "Frontend architecture",
    "Mentoring and leading engineers"
  ]
};

export const skillsData = {
  frontend: [
    "React",
    "TypeScript",
    "Next.js",
    "Vite",
    "Redux / Recoil",
    "TailwindCSS",
    "ShadCN UI",
    "Fabric.js",
    "Storybook"
  ],
  backend: [
    "Node.js",
    "NestJS",
    "Express",
    "GraphQL",
    "REST APIs",
    "Laravel",
    "CodeIgniter 2",
    "Magento 2"
  ],
  cloud: [
    "AWS Serverless Stack",
    "AWS API Gateway",
    "AWS Lambda",
    "AWS CloudFront",
    "AWS Route 53",
    "AWS ECS",
    "Serverless Framework",
    "Docker"
  ],
  database: [
    "MySQL",
    "DynamoDB",
    "MongoDB",
    "Redis"
  ],
  tools: [
    "Git & GitHub",
    "GitHub Actions",
    "CircleCI",
    "Jenkins",
    "Postman",
    "Figma"
  ]
};

export const projectsData = [
  {
    id: 1,
    title: "Enterprise Frontend Platforms",
    description: "Built scalable, testable frontend systems with modern tooling. Led frontend architecture, conducted code reviews, and maintained high code quality standards.",
    techStack: ["React", "Next.js", "TailwindCSS", "ShadCN", "TypeScript"],
    role: "Frontend Lead",
    highlights: ["Design patterns", "High code quality"]
  },
  {
    id: 2,
    title: "AWS Serverless Backend Systems",
    description: "Designed and implemented REST APIs with serverless infrastructure. Managed scalable backend systems for high-performance applications.",
    techStack: ["Node.js", "TypeScript", "AWS Lambda", "API Gateway", "Serverless"],
    role: "Backend Engineer",
    highlights: ["Serverless architecture", "Scalable APIs"]
  },
  {
    id: 3,
    title: "Mobile Applications",
    description: "Developed cross-platform mobile applications focused on performance, reusability, and clean UI architecture.",
    techStack: ["React Native", "TypeScript", "Redux"],
    role: "Mobile Developer",
    highlights: ["Cross-platform", "Clean UI architecture"]
  },
  {
    id: 4,
    title: "eCommerce Platforms",
    description: "Magento 2 PWA development with React and GraphQL backend. Scaled systems using AWS ECS, Redis, and load balancers for high-traffic environments.",
    techStack: ["Magento 2", "React", "GraphQL", "AWS ECS", "Redis"],
    role: "Full Stack Developer",
    highlights: ["High-traffic scaling", "PWA development"]
  },
  {
    id: 5,
    title: "CI/CD & DevOps Automation",
    description: "Implemented automated deployment pipelines for streamlined UAT and production releases. Managed infrastructure and deployment processes.",
    techStack: ["GitHub Actions", "CircleCI", "Jenkins", "Docker"],
    role: "DevOps",
    highlights: ["Automated pipelines", "Production deployments"]
  }
];

export const experienceData = [
  {
    id: 1,
    company: "AzendTech",
    role: "Senior Software Engineer",
    period: "Nov 2024 – Present",
    description: "Building clean, testable frontend components. Leading cross-functional teams and mentoring developers while enforcing code quality standards.",
    achievements: [
      "Leading cross-functional teams",
      "Mentoring developers",
      "Enforcing code quality standards"
    ]
  },
  {
    id: 2,
    company: "Swivel Tech",
    role: "Senior Software Engineer",
    period: "Mar 2024 – Oct 2024",
    description: "Frontend architecture and system design. Collaborated with stakeholders on backlog grooming with ownership of production and UAT deployments.",
    achievements: [
      "Frontend architecture & system design",
      "Stakeholder collaboration",
      "Production & UAT deployment ownership"
    ]
  },
  {
    id: 3,
    company: "Swivel Tech",
    role: "Software Engineer",
    period: "Jun 2022 – Mar 2024",
    description: "Built AWS serverless systems, REST APIs, and managed caching and CDN. Developed React Native mobile applications.",
    achievements: [
      "AWS serverless systems",
      "REST APIs & caching",
      "React Native mobile apps"
    ]
  },
  {
    id: 4,
    company: "NeoSolax",
    role: "Software Engineer",
    period: "Jun 2021 – Jun 2022",
    description: "Magento 2 PWA and backend development. Scaled high-traffic eCommerce platforms.",
    achievements: [
      "Magento 2 PWA development",
      "High-traffic eCommerce scaling"
    ]
  },
  {
    id: 5,
    company: "EFS Solution",
    role: "Associate Software Engineer",
    period: "May 2020 – Jun 2021",
    description: "Built reusable React components using Atomic Design. Developed admin dashboards with PHP, React, and GraphQL.",
    achievements: [
      "React Atomic Design components",
      "Admin dashboards with GraphQL"
    ]
  }
];

export const contactData = {
  email: "pramythrajapaksa@gmail.com",
  message: "I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision.",
  social: {
    github: "https://github.com/pramith",
    linkedin: "https://linkedin.com/in/pramitha-rajapaksa"
  }
};
